import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { getRehydratableName, getClassNameFactory, useFetch } from "../../utilities";
import config from "./ProductDetailsConfig";
import ProductView from "./components/ProductView";

var ProductDetail = function ProductDetail(_ref) {
  var productUrl = _ref.productUrl,
      productErrorMsg = _ref.productErrorMsg,
      productNotFoundMsg = _ref.productNotFoundMsg,
      productLoadingMsg = _ref.productLoadingMsg;
  var getClassName = getClassNameFactory(ProductDetail.displayName);

  var _useFetch = useFetch(productUrl, {}),
      _useFetch2 = _slicedToArray(_useFetch, 3),
      response = _useFetch2[0],
      isLoading = _useFetch2[1],
      error = _useFetch2[2];

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    "data-rehydratable": getRehydratableName(ProductDetail.displayName),
    "data-product-url": productUrl,
    "data-product-error-msg": productErrorMsg,
    "data-product-not-found-msg": productNotFoundMsg,
    "data-product-loading-msg": productLoadingMsg
  }, /*#__PURE__*/React.createElement(ProductView, {
    productData: response,
    isLoading: isLoading,
    error: error,
    productErrorMsg: productErrorMsg,
    productNotFoundMsg: productNotFoundMsg,
    productLoadingMsg: productLoadingMsg
  }));
};

ProductDetail.displayName = "ProductDetail";
ProductDetail.defaultProps = {
  productErrorMsg: config.notifications.error,
  productNotFoundMsg: config.notifications.productNotFound,
  productLoadingMsg: config.notifications.loading
};
export default ProductDetail;